<template>
  <div :class="['loading-container vld-parent', { hidden: !loading }]">
    <loading :active.sync="loading" :is-full-page="false" color="#FC3F00" :width="48" :height="48" />
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay';
export default {
  name: 'AppLoading',
  components: { Loading },
  props: {
    loading: {
      type: Boolean,
      default: () => false
    }
  }
};
</script>

<style scoped>
.loading-container {
  height: 200px;
}
.hidden {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/AppLoading.vue